<template>
  <v-container>
    <v-card
        class="mx-auto"
        max-width="344"
    >
      <v-card-text>
        <div>J'aurai besoin de combien de</div>
        <p class="text-h4 text--primary">
          Café
        </p>
        <div>
          <v-text-field
              v-model="collaborateur"
              label="Nombre de collaborateurs"
              :rules="rules"
              hide-details="auto"
          ></v-text-field>
        </div>
      </v-card-text>
      <v-card-actions>
        <p> {{ calculCafe }} paquets de café</p>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-actions>
        <p> Total: {{ totalDevis }} €</p>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Calculator",
  data: () => ({
    rules: [
      value => !!value || 'Required.',
    ],
    collaborateur: null,
    consoMoy:10,
    poidsMoy:0.007,
    frequence: 4.33,
    poids: 0
  }),
  computed:{
    calculCafe(){
      return Math.round(this.collaborateur * this.consoMoy * this.poidsMoy * this.frequence)
    },
    equival250g(){
      return Math.round(this.calculCafe/0.25)
    },
    totalDevis(){
      return Math.round(this.calculCafe*23.90)
    }
  }
}
</script>

<style scoped>

</style>